export default {
  state: {
    rsvpInMap: {
      id: null
    },
    driversNearRsvp: [],
    driverIdsInMap: [],
    driversInMap: [],
    loadingRsvpId: null,
    loadingDriverId: null
  },
  mutations: {
    clearMap (state) {
      state.rsvpInMap = null
      state.driversNearRsvp = []
      state.driversInMap = []
      state.driverIdsInMap = []
    },
    setRsvpInMap (state, rsvp) { state.rsvpInMap = rsvp },
    removeRsvpInMap (state) {
      state.rsvpInMap = {
        id: null
      }
      state.driversNearRsvp = []
    },
    setDriversNearRsvp (state, drivers) { state.driversNearRsvp = drivers },
    addDriverInMap (state, driver) {
      state.driverIdsInMap.push(driver.id)
      state.driversInMap.push(driver)
    },
    removeDriverInMap (state, driver) {
      for (let i = 0; i < state.driversInMap.length; i++) {
        let driverId = state.driversInMap[i].id
        if (driverId === driver.id) {
          state.driversInMap.splice(i, 1)
          break
        }
      }

      let index = state.driverIdsInMap.indexOf(driver.id)
      if (index > -1) {
        state.driverIdsInMap.splice(index, 1)
      }
    },
    removeAllDriversInMap (state) {
      state.driversNearRsvp = []
      state.driverIdsInMap = []
      state.driversInMap = []
    },
    setLoadingRsvpId (state, value) { state.loadingRsvpId = value },
    setLoadingDriverId (state, value) { state.loadingDriverId = value }
  },
  sharedMutations: [
    'dispatch/clearMap',
    'dispatch/setRsvpInMap',
    'dispatch/removeRsvpInMap',
    'dispatch/setDriversNearRsvp',
    'dispatch/addDriverInMap',
    'dispatch/removeDriverInMap',
    'dispatch/setLoadingRsvpId',
    'dispatch/setLoadingDriverId'
  ]
}


// WEBPACK FOOTER //
// ./src/store/dispatch/dispatch-map.js